import { useEffect } from 'react';

export const useScrollLock = (lock: boolean) => {
  useEffect(() => {
    const body = document.body;

    const unlockBodyScroll = () => {
      const scrollY = Math.abs(parseInt(body.style.top || '0', 10));
      body.classList.remove('scroll-lock');
      body.style.top = '';
      body.style.paddingRight = '';
      window.scrollTo(0, scrollY);
    };

    if (lock) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      body.classList.add('scroll-lock');
      body.style.top = `-${window.scrollY}px`;
      body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      unlockBodyScroll();
    }

    return () => {
      unlockBodyScroll();
    };
  }, [lock]);
};
